import { Row } from 'antd';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { GreenLinkText } from '../../../../layout/globalFonts';
import RouteUrlPaths from '../../../../RouteUrlPaths';
import ContentStore from '../../../../stores/ContentStore';
import TransactionsStore from '../../../../stores/TransactionsStore';

const ButtonRow = styled(Row)`
  margin: 25px 0px;
`;

interface GoToTransactionsAndUsageButtonRowProps {
  contentStore: ContentStore;
  transactionsStore: TransactionsStore;
}

const GoToTransactionsAndUsageButtonRow: FC<GoToTransactionsAndUsageButtonRowProps> = (props) => {
  const { contentStore, transactionsStore } = props;

  return (
    <ButtonRow justify="center">
      <GreenLinkText style={{ cursor: 'pointer' }}>
        <Link
          to={{ pathname: `/${RouteUrlPaths.TransactionAndUsage}` }}
          onClick={() => {
            transactionsStore.setActiveTab(1);
            window.scrollTo({ top: 0 });
            contentStore.rootStore.productStore.productCardStore.closeModal();
            contentStore.rootStore.menuStore.setSelectedMenuItem(RouteUrlPaths.TransactionAndUsage);
          }}
        >
          {contentStore.cmsStore.getContent('SeeAllTransactionsAndUsage')?.content}
        </Link>
      </GreenLinkText>
    </ButtonRow>
  );
};

export default GoToTransactionsAndUsageButtonRow;
